import { NavLink, generatePath } from 'react-router-dom';
import { FeesRoutes } from '../../routes';

import cn from './fees.module.css';

const FeeItem = ({ title, id }: { title: string, id: string }) => (
  <NavLink
    to={generatePath(FeesRoutes.FEES_ITEM, { feeId: id })}
    className={cn.feeItem}
  >
    {title}
  </NavLink>
);

export default FeeItem;
